export const EXPERIMENTS = {
    MULTILINE_ADDRESS_IN_TEMPLATES: 'specs.forms.MultilineAddressInTemplates',
};
//# sourceMappingURL=experiments.js.map